import { enhancedTmsApi } from './enhancedTmsApi'
import type {
  TrainingMatrixPageApiArg,
  TrainingMatrixPageApiResponse,
  TrainingMatrixReportsApiArg,
  TrainingMatrixReportsApiResponse
} from './tmsApi'

// This file is for injecting endpoints into the enhancedTmsApi. It can be used to add endpoints that are not included in the generated tmsApi.ts file.
const customApi = enhancedTmsApi.injectEndpoints({
  endpoints: build => ({
    trainingMatrixPageData: build.infiniteQuery<TrainingMatrixPageApiResponse, TrainingMatrixPageApiArg, number>({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, _allPages, lastPageParam, _allPageParams) => {
          const nextPage = lastPageParam + 1
          const remainingPages = (lastPage?.maxPages ?? 0) - nextPage
          return remainingPages >= 0 ? nextPage : undefined
        }
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/training-matrix/dynamic/${queryArg.reportHash}`,
        params: { page: pageParam }
      })
    }),
    //When tmsApi.ts file is regenerated. These can probably be removed
    gapAnalysisScheduledReports: build.query<TrainingMatrixReportsApiResponse, TrainingMatrixReportsApiArg>({
      query: queryArg => ({
        url: `/schedules/gap-analysis`,
        params: { page: queryArg.page }
      }),
      providesTags: ['schedule-report']
    }),
    trainingMatrixScheduledReports: build.query<TrainingMatrixReportsApiResponse, TrainingMatrixReportsApiArg>({
      query: queryArg => ({
        url: `/schedules/training-matrix`,
        params: { page: queryArg.page }
      }),
      providesTags: ['schedule-report']
    })
  })
})

export const {
  useTrainingMatrixPageDataInfiniteQuery,
  useGapAnalysisScheduledReportsQuery,
  useTrainingMatrixScheduledReportsQuery
} = customApi
